// All DOM lookups live here, so no other module touches `document.querySelector`.

import { state } from './state.js';
import { accessoryPreview, speciesPreview } from './render/preview.js';
import { ACCESSORIES, ACCESSORY_SLOTS, CPU_LEVELS, SITE_URL, SPECIES, TARGET_WINS_CHOICES, TURN_RUSH_SECONDS, TURN_SECONDS_CHOICES } from './config.js';
import {
  achievementList,
  resetSpecialUses,
  savedLooks,
  savedName,
  savedTurnSeconds,
  setTurnSeconds,
  savedTargetWins,
  savedMode,
  setTargetWins,
  savedCpuLevel,
  setCpuLevel,
  specialsOfKind,
  specialSource,
  toggleAccessory,
  topResults,
  unlockedCount,
  unlockedSpecials,
  setLook,
} from './progress.js';
import { MODES, mods } from './modes.js';
import { isOnline, onlineStatus } from './leaderboard.js';
import { SOCIAL_ICONS } from './socialicons.js';
import { LANGS, lang, t } from './i18n.js';

export const angleSlider = document.querySelector('#angle');
export const powerSlider = document.querySelector('#power');
export const angleValue = document.querySelector('#av');
export const powerValue = document.querySelector('#pv');
export const fireBtn = document.querySelector('#fire');
/** The header's music toggle, which is on screen whatever screen you are on. */
export const musicQuick = document.querySelector('#musicquick');
export const musicVol = document.querySelector('#musicvol');
export const fxVol = document.querySelector('#fxvol');
export const musicVolValue = document.querySelector('#musicvolvalue');
export const fxVolValue = document.querySelector('#fxvolvalue');
/** The equipment menu, which is the picker with the descriptions on it. */
export const loadoutPanel = document.querySelector('#loadoutpanel');
/** The two lists, so a button can ask for one and the key can ask for both. */
export const loadoutUltList = document.querySelector('#loadoutults');
export const loadoutGuardList = document.querySelector('#loadoutguards');
export const loadoutClose = document.querySelector('#loadoutclose');
/** The two headings, which have to go when the mode has no specials at all. */
export const loadoutUltLabel = document.querySelector('#loadoutultslabel');
export const loadoutGuardLabel = document.querySelector('#loadoutguardslabel');
export const loadoutWhen = document.querySelector('#loadoutwhen');
/** The share buttons on the title screen. */
export const socialRow = document.querySelector('#socialrow');
export const roundEl = document.querySelector('#round');
/** The turn clock in the header, and the turn-time buttons in the setup screen. */
export const turnClockEl = document.querySelector('#turnclock');
/** The same clock again inside the equipment panel, which covers the header. */
export const panelClockEl = document.querySelector('#panelclock');
export const turnSeg = document.querySelector('#setupturn');
export const targetSeg = document.querySelector('#setuptarget');
export const cpuSeg = document.querySelector('#setupcpu');
const cpuRow = document.querySelector('#setupcpurow');
export const modeEl = document.querySelector('#mode');
/** The header's "first to n", in two pieces: the words, and the number after them. */
export const targetLabelEl = document.querySelector('#targetlabel');
export const targetWinsEl = document.querySelector('#targetwins');
/**
 * The two doors into the chooser: what you attack with, and what you defend with.
 *
 * They are two buttons rather than one because they are two answers to two
 * different questions — and because a single button that opened a list of both
 * made the player read past half of it every time.
 */
export const attackBtn = document.querySelector('#attack');
export const guardBtn = document.querySelector('#guard');
/** The button that braces with the defence being held. Shown only when one is. */
export const braceBtn = document.querySelector('#brace');
export const awardsBtn = document.querySelector('#menuawards');
export const awardPanel = document.querySelector('#awardpanel');
export const awardList = document.querySelector('#awardlist');
export const awardClose = document.querySelector('#awardclose');
export const toastEl = document.querySelector('#toast');
export const menuPlay = document.querySelector('#menuplay');
export const menuResume = document.querySelector('#menuresume');
export const menuBack = document.querySelector('#menuback');
/** The greeting puppets' canvas, over the front end's cards. Drawn by splash.js. */
export const greetCanvas = document.querySelector('#greet');
/** The loading tip on the splash. Filled in by screens.js, which is what owns it. */
export const splashTipEl = document.querySelector('#splashtip');
/** The nudge shown on the splash while the browser is still holding the audio back. */
export const splashHintEl = document.querySelector('#splashhint');
/** The language buttons on the title screen. */
export const langRow = document.querySelector('#langrow');
/** The mode cards are drawn by the setup screen, not by a panel of their own. */
export const modeList = document.querySelector('#setupgrid');
export const charsBtn = document.querySelector('#menuchars');
export const charPanel = document.querySelector('#charpanel');
export const charList = document.querySelector('#charlist');
// El panel tiene un solo botón —`charSave`, al fondo— desde que se quitó el ✕ de la cabecera: eran
// dos haciendo el mismo trabajo y el jugador los veía desde sitios distintos de la misma lista.
export const charSave = document.querySelector('#charsave');
export const rankPanel = document.querySelector('#rankpanel');
export const rankList = document.querySelector('#ranklist');
export const rankClose = document.querySelector('#rankclose');
// El botón de las clasificaciones, que vive en la portada: estaba en el menú y el jugador lo
// buscaba antes de entrar (ver index.html).
export const titleRanks = document.querySelector('#titleranks');
/**
 * El campo del nombre, en la portada y junto al código de partida.
 *
 * Tenía un gemelo en el panel de clasificaciones —«un nombre, dos puertas»— y ya es la única
 * puerta: ver la nota en index.html, donde estaba aquel campo.
 */
export const titleNameEl = document.querySelector('#titlename');
export const rankRefresh = document.querySelector('#rankrefresh');
export const rankStatus = document.querySelector('#rankstatus');
export const localList = document.querySelector('#locallist');
export const linkPanel = document.querySelector('#linkpanel');
export const linkClose = document.querySelector('#linkclose');
export const shareBtn = document.querySelector('#sharebtn');
export const shareCode = document.querySelector('#sharecode');
export const shareMsg = document.querySelector('#sharemsg');

// --- the front-end ---------------------------------------------------------

export const shellEl = document.querySelector('.shell');

/** One entry per screen. screens.js decides which of them is showing. */
export const screens = {
  splash: document.querySelector('#splash'),
  title: document.querySelector('#title'),
  menu: document.querySelector('#menu'),
  setup: document.querySelector('#setup'),
  pause: document.querySelector('#pause'),
  results: document.querySelector('#results'),
};

export const startBtn = document.querySelector('#startbtn');
/**
 * The random-match button, under PLAY NOW, and the line that has to be honest under it.
 */
export const againstRow = document.querySelector('#setupagainst');
export const againstCpuEl = document.querySelector('#againstcpu');
export const againstRandomEl = document.querySelector('#againstrandom');
/** With two players: one phone each, or one keyboard between them. */
export const duelRow = document.querySelector('#setupduel');
export const duelCodeBtn = document.querySelector('#duelcode');
export const duelHotseatBtn = document.querySelector('#duelhotseat');
export const poolNote = document.querySelector('#poolnote');
/** The panel that replaces the front page while the pool is being asked. */
export const searching = document.querySelector('#searching');
export const searchText = document.querySelector('#searchtext');
export const searchCpu = document.querySelector('#searchcpu');
export const searchCancel = document.querySelector('#searchcancel');
/** The code field on the title screen, between the play button and the sharing. */
export const joinCode = document.querySelector('#joincode');
export const menuBtn = document.querySelector('#menubtn');
/** The field itself. The only double click in the game is aimed at it. */
export const gameCanvas = document.querySelector('#game');
export const setupGrid = document.querySelector('#setupgrid');
export const setupP1 = document.querySelector('#setupp1');
export const setupP2 = document.querySelector('#setupp2');
export const setupStart = document.querySelector('#setupstart');
export const setupBack = document.querySelector('#setupback');
export const resultsHead = document.querySelector('#resultshead');
export const resultsScore = document.querySelector('#resultsscore');
export const resultsAgain = document.querySelector('#resultsagain');
export const resultsSetup = document.querySelector('#resultssetup');
export const resultsRanks = document.querySelector('#resultsranks');
export const resultsMenu = document.querySelector('#resultsmenu');
export const pauseResume = document.querySelector('#pauseresume');
export const pauseRestart = document.querySelector('#pauserestart');
export const pauseSetup = document.querySelector('#pausesetup');
export const pauseShare = document.querySelector('#pauseshare');
export const pauseMenu = document.querySelector('#pausemenu');
/** The way out of a match for good: it ends it and goes back to the front page. */
export const pauseHome = document.querySelector('#pausehome');
/** The line on the pause card that says whose turn it was. */
export const pauseTurnEl = document.querySelector('#pauseturn');

/**
 * El nombre de quien actúa: el nick, la máquina, o «jugador 2».
 *
 * El nick manda en el lado propio: quien lo escribe en la portada lo espera en la partida, y ahí
 * ponía «P1» y nada más. El otro lado sigue siendo lo que es — la máquina, el rival de la red, o
 * el segundo jugador del teclado, que no tiene nick porque el campo es uno.
 */
export function playerName(index) {
  const mine = savedName();
  if (index === 0) return (state.cpuOn || state.online) && mine ? mine : t('char.player1');
  if (state.online) return index === state.seat ? t('char.you') : (state.rival || t('char.rival'));
  return t(state.cpuOn ? 'hud.cpu' : 'char.player2');
}

/**
 * The mark at the front of a label: an emoji, an arrow, or one of the few symbols the labels use.
 *
 * Written out rather than taken as "everything that is not a letter", because the point of the
 * match is the mark and nothing else: the `▾` at the end of ARMED: BALL × 1 ▾ is an indicator and
 * stays small, and a card's own icon is in a span of its own. So only the first cluster of the
 * string counts, and only if it is one of these.
 */
const MARK = /^(?:[\u2190\u21bb\u2302]\uFE0F?|\p{Extended_Pictographic}\uFE0F?(?:\u200D\p{Extended_Pictographic}\uFE0F?)*)/u;

/**
 * Lifts the mark out of a label and gives it a size of its own.
 *
 * The icons live inside the translated strings, which is why they have always been set at the
 * button's own size — a 13px mark on a 54px card, measurably: 15px of glyph in 211x54 against 12
 * of type. Editing the icon out of six dictionaries is not the fix; taking it out of the string on
 * the way to the screen is, and it is one function because the mark is the same piece of the
 * sentence in every language.
 *
 * Idempotent on purpose, and that is what makes it safe to call from a pass that runs on every
 * change: an element whose first child is already the wrapper is left alone, so calling it twice
 * cannot wrap twice.
 *
 * `aria-hidden`, because it is not read out: the word beside it says the same thing.
 */
export function iconify(el) {
  const text = el && el.firstChild;

  // Nothing of the label's own here: already done, or the icon belongs to a child — the card's
  // icon is a span, the language button starts with a flag, and a species button is a picture.
  if (!text || text.nodeType !== 3) return;

  const mark = text.textContent.match(MARK);
  if (!mark) return;

  const ico = document.createElement('span');
  ico.className = 'ico';
  ico.setAttribute('aria-hidden', 'true');
  ico.textContent = mark[0];

  text.textContent = text.textContent.slice(mark[0].length);
  el.insertBefore(ico, text);
}

/**
 * Every button on the page, for the labels this module did not just write.
 *
 * The seven places that write a label themselves call iconify() on their own button; this is for
 * the static chrome, which is written by the language pass and never comes through here. It runs
 * with the labels, which is every change of state, of turn and of language — and it is cheap:
 * a button that is already done is one nodeType check.
 */
export function iconifyAll() {
  document.querySelectorAll('button').forEach(iconify);
}

/**
 * Whose turn it was, written on the pause card.
 *
 * For whoever is sitting next to the person who pressed Escape. The card stops the
 * game and covers the field, and the only other place that answers the question is the
 * caption the field puts up when the turn changes — which is gone again a second later.
 *
 * Two-player matches only. Against the CPU the answer is always the same and there
 * is nobody to tell, so the line is not there to be read past.
 */
function updatePauseTurn() {
  if (!pauseTurnEl) return;

  const show = !state.cpuOn && state.matchLive;
  pauseTurnEl.hidden = !show;

  if (show) pauseTurnEl.textContent = t('pause.turn', { name: playerName(state.turn) });
}

/**
 * What the two action buttons say.
 *
 * The throw button said THROW BANANA whatever was armed, which was a plain lie: with the
 * ball armed the player pressed a button promising a banana and reported that the special
 * had not replaced it. Now each button names what it is about to do — the throw takes the
 * ball, the grenade and the leap, the brace takes the three defences — which is why one
 * table covers both: the ids do not overlap. The ones that only change how the banana
 * flies, longer sight or less wind or more crater, keep the throw, because that is still
 * what they are.
 */
const FIRE_KEYS = {
  ball: 'play.fireBall',
  grenade: 'play.fireGrenade',
  leap: 'play.fireLeap',
  sheep: 'play.fireSheep',
  shield: 'play.fireShield',
  spring: 'play.fireSpring',
  mushroom: 'play.fireMushroom',
};

/**
 * The button that braces with the defence being held.
 *
 * A defence used to be spent by pressing the throw button, which worked only while
 * there was one slot and one thing in it. With an attack and a defence carried at once
 * — the point of the two slots — bracing needs an action of its own, or the turn would
 * have two answers and no way to say which.
 */
/**
 * True while the machine has the turn.
 *
 * Every control that belongs to a person asks this — the throw, the brace and the two
 * buttons that open the equipment panel — and each of them used to write the condition out
 * again. The throw button needs it from outside now as well, because the keyboard is not a
 * mouse and has to be told the same thing the button is showing.
 */
export function machineHasTurn() {
  // A rival over the wire is the machine's shape from this side of the screen: the turn is
  // theirs, the controls here are nobody's, and the only difference is who is throwing.
  return (state.cpuOn || state.online) && state.turn !== state.seat;
}

/**
 * Which side the person at this keyboard is on.
 *
 * Every mode puts them somewhere else. In a duel of two people in the same room both sides
 * are theirs and the question does not arise; against the machine they are side zero; and
 * if they answered a random match they are whichever seat the pool gave them. Four places
 * used to write `state.cpuOn ? 0 : state.turn` out by hand, which is the right answer for
 * three of the cases and says nothing at all about a person on another machine.
 */
export function humanSide() {
  if (state.online) return state.seat;
  return state.cpuOn ? 0 : state.turn;
}

/**
 * The side the equipment controls are for: the two buttons in the bar and the panel that
 * opens from them.
 *
 * Against the machine, or over the wire, there is only one bag the person at this keyboard
 * may reach into, and this is it. On his own turn it is what he is about to throw; on the
 * other one's it is what he sets up for his next, and that is the whole reason those two
 * buttons are no longer shut while the other side plays. Choosing early costs nobody
 * anything: a shot reads its slot at the moment it is launched and not before, so an entry
 * made while the rival is in the air can only ever be spent on the next turn. There is
 * nothing for a disabled button to protect.
 *
 * A duel of two people at one keyboard has no "his own" — both bags are in reach — so there
 * the controls follow the turn, and change hands the moment the shot leaves: from then on
 * the thrower has spent his turn and the next player is the only one with anything left to
 * decide.
 */
export function prepareSide() {
  if (state.cpuOn || state.online) return humanSide();
  return shotAway() ? 1 - state.turn : state.turn;
}

/** Whether the side whose turn it is has already thrown it. */
function shotAway() {
  return !!(state.projectile || state.leap || state.sheep);
}

export function updateBraceLabel() {
  if (!braceBtn) return;

  // Against the CPU: the human's side, and not while the CPU is the one thinking.
  const side = humanSide();
  const id = mods().specials ? state.guard[side] : null;

  braceBtn.hidden = !id;
  braceBtn.disabled = machineHasTurn();

  if (id) {
    braceBtn.textContent = t(FIRE_KEYS[id] || 'special.guard');
    iconify(braceBtn);
  }
}

export function updateFireLabel() {
  // The human's side. Against the CPU the button belongs to whoever is throwing, and
  // announcing the CPU's selection before it throws would give away the one piece of
  // information it keeps to itself.
  const side = humanSide();
  const id = mods().specials ? state.special[side] : null;

  // Y con el turno del otro, el botón dice qué se está esperando en vez de nombrar un tiro: se
  // queda donde está — ver `#fire.away` — y el que era un agujero en medio del campo pasa a ser
  // la respuesta a la pregunta que hacía el agujero.
  const waiting = machineHasTurn();

  fireBtn.textContent = waiting ? t('play.waiting') : t(FIRE_KEYS[id] || 'play.fire');
  iconify(fireBtn);
  // Y dicho, no solo enseñado: en el marcado sigue siendo un botón, y un lector de pantalla leería
  // una etiqueta que no se ofrece.
  fireBtn.setAttribute('aria-disabled', String(waiting));

  // Y dicho con una clase y no con el atributo `hidden`: un elemento que no se muestra no corre
  // ninguna transición, así que esconderlo solo podía hacer que desapareciera de un fotograma al
  // siguiente. Qué hace cada uno de los dos silencios lo decide la hoja de estilos.
  //
  // The other road to "not available" is a turn already spent, which is the button's own
  // `disabled`, set by the shot rather than by the turn. The two no longer look alike: one
  // leaves and one stays and says so — see #fire, where the two roads are told apart.
  fireBtn.classList.toggle('away', waiting);
}

/** Pushes the current state into the readouts (angle, power, round, wins). */
export function updateLabels() {
  angleValue.textContent = angleSlider.value + '°';
  powerValue.textContent = powerSlider.value + '%';

  // Only while a match is actually on. The header sits on every screen, so an
  // unconditional number invents a round 1 before you have started playing, and
  // worse, keeps announcing the last round of a match that is already over. A dash
  // says nothing rather than something untrue, and holds the badge's width.
  roundEl.textContent = state.matchLive
    ? t('hud.round', { n: String(state.round).padStart(2, '0') })
    : t('hud.noRound');

  // Cheap enough to ride along with the labels, and a change of turn is exactly when
  // the clock is worth a look — the one readout that moves on its own.
  updateTurnClock();
  // And the length of the match, which is not a setting once a match has started: it comes from the
  // match, and the match can arrive from the other end of a wire. Here for the same reason as the
  // clock — this runs on every change, and receiving a code is one.
  updateTargetLabel();
  // And the pause card, which says whose turn is waiting behind it. It rides along
  // for the same reason: a turn cannot change without the labels being refreshed, so
  // this is the one place that has to be right, and refreshText() comes through here
  // too, which is what keeps it in the reader's language.
  updatePauseTurn();

  // And the way back into the match, which is only a way back into a match if there is somebody
  // to play it with. A duel whose code has not been answered — or a room whose other seat has
  // gone empty — is not a match you can go and play: the other gorilla is not even drawn, and
  // unpausing would put the player in front of a board with nothing to shoot at. So the button
  // waits. Here rather than with the menu's buttons, which are refreshed on the way in and out of
  // screens: this function runs on every change of turn, of state and of language, which is every
  // moment the answer can change.
  if (pauseResume) pauseResume.disabled = state.awaitingRival;
  // Y el otro botón que vuelve a la partida, por lo mismo: desde el menú, VOLVER A LA PARTIDA se
  // guiaba solo por `matchLive`, que está en true aunque el rival no haya llegado. Los dos pasan
  // por `backToMatch` (input.js), que es quien decide; esto es solo que se vea.
  if (menuResume) menuResume.disabled = state.awaitingRival;
  // The throw button names what it is about to do, and a turn change is one of the two
  // things that can alter that: the other is picking a special, which goes through here
  // as well.
  updateFireLabel();
  updateBraceLabel();
  // And the two buttons that open the equipment panel, for the same reason those two are
  // here: they speak for the side that is playing, so a turn change has to reach them.
  // Nothing did, which left them enabled — and about the other player's bag — for as long
  // as the other side's turn lasted.
  updateSpecialButton();
  // And the marks at the front of the labels, which are the one part of a button that is not a
  // word: the static chrome is written by the language pass without them, so this is where they
  // get their own size back — and the seven dynamic labels call iconify() themselves, because a
  // label rewritten after this pass would otherwise be the only one left unwrapped.
  iconifyAll();
}

/**
 * Seconds left in the turn, or Infinity when nobody is being timed.
 *
 * The held stretch comes off the elapsed time rather than the clock being stopped,
 * so that releasing it is a single addition and there is no second clock to keep
 * in step. The marker is set and cleared by advanceTurnClock alone, which asks
 * every frame whether the player is in a position to act.
 */
export function secondsLeft() {
  // El reloj de la partida, no el del ajuste: es el que se copió al empezarla y el que viaja en el
  // código (ver state.turnSeconds). El ajuste sigue mandando en la pantalla de ajustes, que es
  // donde se elige (ver renderTurnChoices, unas líneas más abajo).
  const total = state.turnSeconds;
  if (!total) return Infinity;

  // El tramo en pausa, medido sin salirse de este turno: el mismo tope que usa advanceTurnClock
  // al devolverlo (`Math.max(turnHoldSince, turnStartedAt)`). Sin él, una pausa que empezó antes
  // que el turno —el móvil de pie, o el zurrón que la primera partida abre sola— le regalaba al
  // reloj todo el rato que el juego llevaba abierto: medido, un turno de 15 marcaba 18 con el
  // panel delante y volvía a 15 al cerrarlo, un salto de tres segundos que no eran de nadie.
  const since = Math.max(state.turnHoldSince, state.turnStartedAt);
  const held = state.turnHoldSince ? state.clock - since : 0;
  return total - (state.clock - state.turnStartedAt - held) / 1000;
}

/** The clock, written to both places it is shown. */
export function updateTurnClock() {
  if (!turnClockEl) return;

  const left = secondsLeft();
  if (!isFinite(left) || (state.screen !== 'game' && state.screen !== 'pause')) {
    turnClockEl.hidden = true;
    if (panelClockEl) panelClockEl.textContent = '';
    return;
  }

  const text = `⏱ ${Math.max(0, Math.ceil(left))}`;
  const rush = String(left <= TURN_RUSH_SECONDS);

  turnClockEl.hidden = false;
  turnClockEl.textContent = text;
  turnClockEl.dataset.rush = rush;

  // The panel copy is only ever seen with the panel open, so it needs no hiding of
  // its own: it is emptied when there is no clock and written otherwise.
  if (panelClockEl) {
    panelClockEl.textContent = text;
    panelClockEl.dataset.rush = rush;
  }
}

/**
 * The turn-time buttons, built from the choices in config.js.
 *
 * Built rather than written into the HTML so that the list of choices and the list
 * of buttons cannot drift apart.
 */
export function renderTurnChoices() {
  if (!turnSeg) return;

  const now = savedTurnSeconds();
  turnSeg.innerHTML = TURN_SECONDS_CHOICES.map(n => `<button class="seg" type="button"
    data-seconds="${n}" data-chosen="${n === now}" aria-pressed="${n === now}">${n ? n + ' s' : t('setup.noLimit')}</button>`).join('');
}

/**
 * Chooses the turn time. The setup screen's click lands here rather than in
 * progress.js, so that applying the choice and redrawing the buttons are the same
 * act and cannot be done one without the other.
 */
export function chooseTurnSeconds(seconds) {
  setTurnSeconds(seconds);
  renderTurnChoices();
  updateLabels();
}

/**
 * The match-length buttons, built from the choices in config.js for the same reason the turn times
 * are: one list, so the buttons and the rule that reads it cannot drift apart.
 *
 * The last one is not a number of rounds at all — it is the match that never ends — and it says so
 * in words rather than as an infinity sign, which is also what the header says when it is picked.
 */
export function renderTargetChoices() {
  if (!targetSeg) return;

  const now = savedTargetWins();
  targetSeg.innerHTML = TARGET_WINS_CHOICES.map(n => `<button class="seg" type="button"
    data-wins="${n}" data-chosen="${n === now}" aria-pressed="${n === now}">${n || t('setup.noLimit')}</button>`).join('');
}

/**
 * Chooses how long the match is, and only that: what it sets is the setting, which is what the NEXT
 * match is built from. The match on screen keeps the finish line it was built with, so a change here
 * cannot move it under the two who are playing it.
 */
export function chooseTargetWins(wins) {
  setTargetWins(wins);
  renderTargetChoices();
  updateTargetLabel();
}

/**
 * The difficulty buttons, built from the list in config.js for the same reason the turn
 * times are — and shown only against the machine.
 */
export function renderCpuChoices() {
  if (!cpuSeg) return;

  if (cpuRow) cpuRow.hidden = !state.cpuOn || state.against === 'random';

  // Who the single player is up against, and it is only a question when there is a single
  // player: with two of them in the room there is nobody left to choose. The CPU row is
  // this row's follow-up, which is why a random rival hides it — there is no difficulty to
  // pick for somebody you have not met — and why the two of them are drawn together.
  if (againstRow) againstRow.hidden = !state.cpuOn;
  [[againstCpuEl, state.against === 'cpu'], [againstRandomEl, state.against === 'random']]
    .forEach(([el, on]) => {
      if (el) el.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

  // And the row that takes over from it when there are two players: they are both in the room,
  // so who is on the other side is settled, and where they are is not. Drawn here rather than
  // in renderSetup because it is the same question as the row above it, and the two must not
  // ever both be up: one is about a single player's rival, the other about a second player.
  if (duelRow) duelRow.hidden = state.cpuOn;
  [[duelCodeBtn, 'code'], [duelHotseatBtn, 'hotseat']]
    .forEach(([el, duel]) => {
      if (el) el.setAttribute('aria-pressed', state.duel === duel ? 'true' : 'false');
    });

  const now = savedCpuLevel();
  cpuSeg.innerHTML = CPU_LEVELS.map(l => {
    const label = 'setup.cpu' + l.id[0].toUpperCase() + l.id.slice(1);
    return `<button class="seg" type="button" data-level="${l.id}" data-chosen="${l.id === now}" aria-pressed="${l.id === now}">${t(label)}</button>`;
  }).join('');
}

/** Chooses the difficulty, the same way and in the same place as the turn time. */
export function chooseCpuLevel(id) {
  setCpuLevel(id);
  renderCpuChoices();
}

/**
 * The networks it is worth offering a link to, in the order they are shown.
 *
 * Instagram is the odd one and it is not an oversight. It has no web address you can
 * hand a link to — there is no sharer.php for it — so the only way a link gets there
 * from a browser is the phone's own share sheet. That button asks for one, and where
 * there is none, which is every desktop, it copies the link instead rather than
 * opening a page that cannot do anything.
 */
const SOCIAL = [
  { id: 'whatsapp', to: u => `https://wa.me/?text=${encodeURIComponent(u)}` },
  { id: 'telegram', to: u => `https://t.me/share/url?url=${encodeURIComponent(u)}` },
  { id: 'facebook', to: u => `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(u)}` },
  { id: 'x', to: u => `https://twitter.com/intent/tweet?url=${encodeURIComponent(u)}` },
  { id: 'instagram', share: true },
  { id: 'copy', copy: true },
];

/** Exported so the click handler and this table cannot disagree about the link. */
export const SOCIAL_URL = SITE_URL;

/** Where each network's button points, or null for the two that do not point anywhere. */
export function socialTarget(id) {
  const entry = SOCIAL.find(x => x.id === id);
  return entry && entry.to ? entry.to(SITE_URL) : null;
}

export function socialNeedsTheShareSheet(id) {
  const entry = SOCIAL.find(x => x.id === id);
  return !!(entry && entry.share);
}

export function socialIsACopy(id) {
  const entry = SOCIAL.find(x => x.id === id);
  return !!(entry && entry.copy);
}

/** The row itself. Follows the language, so it is redrawn with everything else. */
export function renderSocial() {
  if (!socialRow) return;

  socialRow.innerHTML = SOCIAL.map(s => `<button class="secondary socialbtn" type="button"
    data-social="${s.id}" title="${t(`social.${s.id}`)}" aria-label="${t(`social.${s.id}`)}">${SOCIAL_ICONS[s.id]}</button>`).join('');
}

/**
 * Copies the shareable link, and says so — or says it could not. The fallback matters:
 * a browser can refuse the clipboard, and silence would look like a dead button.
 */
export async function copyShareLink() {
  try {
    await navigator.clipboard.writeText(SITE_URL);
    showToast(t('toast.copied'));
  } catch {
    showToast(t('toast.copyFailed'));
  }
}

/**
 * The equipment menu.
 *
 * Every special in the game is listed, not only the ones in the bag. An entry you
 * cannot pick yet still says what it does and which award hands it over, which is
 * the difference between a shopping list and a taunt — and the descriptions are
 * the whole reason this menu exists rather than just the row of buttons in the
 * pause screen. Picking one here arms it for the next throw, with the text that
 * explains it in front of you.
 */
export function renderLoadout(kind = null) {
  if (!loadoutPanel) return;

  // A mode without specials has nothing to offer here, and eleven cards that
  // cannot be picked would read as a bug rather than as a rule. The headings go
  // too: two empty lists under two labels is the same mistake in a smaller font.
  if (!mods().specials) {
    loadoutUltLabel.hidden = true;
    loadoutGuardLabel.hidden = true;
    loadoutUltList.hidden = true;
    loadoutGuardList.hidden = true;
    loadoutUltList.innerHTML = `<span class="panelnote">${t('loadout.off')}</span>`;
    loadoutGuardList.innerHTML = '';
    loadoutWhen.hidden = true;
    return;
  }

  // One list at a time when a button asked for it, both when the key did. The key is
  // the overview; the buttons are for the half you already know you want.
  const showUlts = kind !== 'guard';
  const showGuards = kind !== 'ult';
  loadoutUltLabel.hidden = !showUlts;
  loadoutGuardLabel.hidden = !showGuards;
  loadoutUltList.hidden = !showUlts;
  loadoutGuardList.hidden = !showGuards;

  // The bag the panel shows is the one the controls are for, and so is the one a card
  // writes to — see prepareSide(). Against the machine that is this side whether or not it
  // is the one throwing, which is what the panel used to get wrong by reading the turn.
  const side = prepareSide();
  const mine = state.specialUses[side] || {};

  // And when the pick is not for the turn being played, the panel says so. Nothing else on
  // screen would change: the buttons show the same slot either way.
  loadoutWhen.hidden = side === state.turn;

  const card = (id, kind) => {
    const left = mine[id] || 0;
    const owned = unlockedSpecials().includes(id);
    // The card's own kind is what says which of the two slots it belongs in.
    const chosen = (kind === 'guard' ? state.guard[side] : state.special[side]) === id;
    const source = specialSource(id);
    const note = owned
      ? t(`special.${id}.hint`)
      : t('loadout.howto', { name: source ? t(`ach.${source}.name`) : '?' });

    return `<button class="secondary loadoutcard" type="button" data-id="${id}" data-kind="${kind}"
      data-chosen="${chosen}" data-owned="${owned}" data-empty="${left === 0}"
      ${owned && left > 0 ? '' : 'disabled'}>
      <span class="loadoutname">${t(`special.${id}.name`)}${owned ? `<b> ×${left}</b>` : ''}</span>
      <span class="loadouthint">${note}</span>
    </button>`;
  };

  const list = kind => specialsOfKind(kind).map(id => card(id, kind)).join('');
  loadoutUltList.innerHTML = list('ult');
  loadoutGuardList.innerHTML = list('guard');
}

/**
 * Each side keeps its own aim.
 *
 * There is one pair of sliders on screen and both sides use it, so without this
 * the CPU's angle and power simply stay where it left them and the player comes
 * back to a shot they never dialled. Saved as a shot is fired, put back when the
 * turn comes round — which also gives two people sharing a keyboard their own aim
 * back instead of making them re-aim from scratch every turn.
 */
export function resetAims() {
  const now = { angle: Number(angleSlider.value), power: Number(powerSlider.value) };
  state.aim = [{ ...now }, { ...now }];
}

/** Files whatever is on the sliders under one side. */
export function saveAim(idx) {
  if (!state.aim || !state.aim[idx]) resetAims();
  state.aim[idx] = { angle: Number(angleSlider.value), power: Number(powerSlider.value) };
}

/**
 * Puts a side's own aim back on the sliders.
 *
 * Deliberately no draw() from here: the frame loop repaints the aiming preview on
 * the next frame anyway, and this module has no business knowing about the
 * renderer.
 */
export function loadAim(idx) {
  if (!state.aim || !state.aim[idx]) resetAims();

  const aim = state.aim[idx];
  angleSlider.value = aim.angle;
  powerSlider.value = aim.power;
  updateLabels();
}

/** Keeps the header badge in sync with the CPU toggle. */
export function updateModeLabel() {
  modeEl.textContent = state.online
    ? t('hud.vsOnline', { name: state.rival || t('char.rival') })
    : t(state.cpuOn ? 'hud.vsCpu' : 'hud.twoPlayer');
}

/**
 * The list of music buttons that have to agree with each other.
 */
/**
 * The two levels, in the readouts and in the sliders themselves.
 *
 * Reads the state rather than the control, so the slider is put where the setting is even when
 * it was the slider itself that moved — which is what keeps a level clamped by `asLevel` from
 * leaving the thumb somewhere the mix is not.
 */
export function updateVolumeLabels() {
  const sync = (el, out, v) => {
    if (!el) return;
    el.value = String(Math.round(v * 100));
    if (out) out.textContent = Math.round(v * 100) + '%';
  };

  sync(musicVol, musicVolValue, state.musicVolume);
  sync(fxVol, fxVolValue, state.fxVolume);
}

/**
 * Keeps every sound control in step. There are three of them — the quick switch in the header and
 * the two levels in the pause menu — and none of them is ever allowed to disagree with the
 * settings they are showing.
 *
 * The menu's own switch is gone, and the panel is the better for it: it was the same setting as
 * the music level beside it, said twice with two different sets of words. What the panel keeps is
 * the question only it can answer.
 */
export function updateMusicLabel() {
  // The levels ride along with the switch: they are one setting seen from three places, and the
  // panel that shows one of them shows all of them. Before the early return below, which is
  // about the header's button and nothing else.
  updateVolumeLabels();

  if (!musicQuick) return;

  const label = t(state.musicOn ? 'music.on' : 'music.off');
  musicQuick.textContent = state.musicOn ? '🎵' : '🔇';
  iconify(musicQuick);
  musicQuick.setAttribute('aria-pressed', String(state.musicOn));
  musicQuick.setAttribute('aria-label', label);
  musicQuick.title = label;
  musicQuick.dataset.on = String(state.musicOn);
}

/**
 * Keeps the header's "first to n" in step with the match's own finish line.
 *
 * The words change with it: a match with no end to it is not a number with a dash after it, and
 * "FIRST TO" followed by nothing says less than the two words that mean it. The number is hidden
 * rather than emptied so the badge cannot read as a word followed by a gap.
 */
export function updateTargetLabel() {
  const wins = state.targetWins;

  targetLabelEl.textContent = wins ? t('hud.firstTo') : t('setup.noLimit');
  targetWinsEl.textContent = wins ? String(wins) : '';
  targetWinsEl.hidden = !wins;
}

// --- awards and specials ---------------------------------------------------

/** Specials with charges left, in the order the player cycles through them. */
export function usableSpecials() {
  const mine = state.specialUses[0] || {};
  return unlockedSpecials().filter(id => (mine[id] || 0) > 0);
}

/**
 * Tops up the charges for anything just earned. A special unlocked mid-match has
 * to be usable in that same match, not the next one — otherwise the button sits
 * there saying SPENT while the player is holding a brand new toy.
 */
export function grantNewSpecials() {
  const fresh = resetSpecialUses();
  const mine = state.specialUses[0];

  Object.keys(fresh).forEach(id => {
    if (mine[id] === undefined) mine[id] = fresh[id];
  });
}

/**
 * Everything one achievement hands over. Listed in full: an achievement can grant
 * more than one thing, and showing only the first would make the panel lie about
 * what the player has actually earned.
 */
function rewardLabel(reward) {
  if (!reward) return '';

  const parts = [];
  if (reward.antic) parts.push(t('award.rewardAntic', { name: t('antic.' + reward.antic) }));
  if (reward.special) parts.push(t('award.rewardSpecial', { name: t('special.' + reward.special + '.name') }));
  // `specials` is the plural form half the table uses (the ball, the mushroom, the boomerang),
  // and it was the half this function ignored: those awards showed no reward at all, which is
  // exactly the lie the comment above swears it does not tell.
  (reward.specials || []).forEach(id => {
    parts.push(t('award.rewardSpecial', { name: t('special.' + id + '.name') }));
  });

  return parts.join(' · ');
}

/**
 * Keeps the two buttons in step with what is armed and what is left.
 *
 * They speak for whoever is playing — the same side `updateLabels` reads for the throw
 * button — and they go dead on the machine's turn, for the same reason the brace does:
 * there is nobody at the machine to spend anything, and a button that opens the panel on
 * its turn opens it on the machine's own bag, which is a human editing the machine's ult.
 */
export function updateSpecialButton() {
  // The same rule the brace and the throw label use: against the machine the controls
  // speak for the human's side — showing the machine's own bag would hand the player the
  // one thing it keeps to itself — and in a game of two people they follow the turn.
  const side = prepareSide();

  // El botón se escribe en dos líneas: arriba lo que el botón ES —⚔ ATTACK— y debajo, en pequeño,
  // lo que hay elegido. En una sola línea no cabe de ninguna manera: medido, «⚔ ATTACK: BOOMERANG
  // × 2 ▾» ocupa 244 px en un botón de 130, y con `nowrap` (que está ahí para que el `▾` no se caiga
  // a la línea de abajo) lo que sobraba se recortaba a la mitad.
  const write = (btn, slot, pick) => {
    // La primera línea va SIEMPRE envuelta en su span, aunque no haya segunda, y `iconify` va sobre
    // ESE span y no sobre el botón. Es la diferencia entre una línea y dos: `iconify` mete el icono
    // como primer hijo del elemento que le den, y el botón es una columna flex — con el icono suelto
    // ahí dentro se convierte en un flex-item y se lleva su propia línea, así que salía el `⚔` arriba
    // centrado y «ATTACK ▾» debajo. Dentro de `.slot` vuelve a ser lo que era: un trozo de la misma
    // línea que el texto, a 1.5em como los iconos de las tarjetas de modo.
    btn.innerHTML = `<span class="slot">${slot}</span>${pick ? `<span class="pick">${pick}</span>` : ''}`;
    btn.title = pick || '';
    iconify(btn.querySelector('.slot'));
  };

  // A mode without specials says so on both of them, rather than offering a button
  // that will silently refuse to spend anything.
  if (!mods().specials) {
    [[attackBtn, 'special.attack'], [guardBtn, 'special.guard']].forEach(([btn, key]) => {
      btn.disabled = true;
      btn.setAttribute('aria-pressed', 'false');
      // El porqué, entero y por escrito, en el tooltip: en el botón no cabe y el panel de equipo
      // ya lo dice con estas mismas palabras (`loadout.off`).
      write(btn, `${t(key)} ▾`, t('special.off'));
      btn.title = t('loadout.off');
    });
    return;
  }

  // Each button owns a slot now. They used to share one and each hide the half that was
  // not theirs, which was the only thing keeping a single selection honest.
  const set = (btn, labelKey, id) => {
    const left = id ? (state.specialUses[side][id] || 0) : 0;

    // Not switched off while the other side plays, which is what these two used to do. An
    // entry made now is this side's next turn, so there is nothing to protect from it.
    btn.disabled = false;
    // El nombre entero sigue estando, en su línea y en pequeño; en el botón sólo cabía el prefijo.
    write(btn, `${t(labelKey)} ▾`, id ? `${t('special.' + id + '.name')} × ${left}` : '');
    btn.dataset.armed = String(!!id);
    btn.setAttribute('aria-pressed', String(!!id));
  };

  set(attackBtn, 'special.attack', state.special[side]);
  set(guardBtn, 'special.guard', state.guard[side]);
}

/**
 * Rebuilds the award panel. The strings are our own constants, never anything
 * that came from outside the game.
 */
export function renderAwards() {
  const list = achievementList();

  awardList.innerHTML = list
    .map(a => `
      <li data-unlocked="${a.unlocked}">
        <span class="tick">${a.unlocked ? '✓' : '·'}</span>
        <span><span class="awardname">${a.name}</span><br><span class="awardhint">${a.hint}</span></span>
        <span class="awardreward">${rewardLabel(a.reward)}</span>
      </li>`)
    .join('');

  awardsBtn.textContent = t('award.progress', { n: unlockedCount(), total: list.length });
  iconify(awardsBtn);
}

let toastTimer = null;

/**
 * Flashes a notice at the top of the screen.
 *
 * `kind` is not decoration. A reward arrives while the player is looking somewhere else and
 * has to be dressed as gold to be caught; an achievement is the loudest thing the game ever
 * says, and gets the biggest box, the longest hold and a glow that keeps breathing while it
 * is up. Everything else a toast says — a link copied, a code refused — is a note about
 * something the player has just done himself, and a note can be quiet.
 */
export function showToast(text, { kind = null } = {}) {
  toastEl.textContent = text;
  toastEl.classList.toggle('reward', kind === 'reward');
  toastEl.classList.toggle('award', kind === 'award');
  toastEl.hidden = false;
  clearTimeout(toastTimer);
  // Más cortos que antes (eran 5000/4200/3400): un cartel que tapa el campo de juego se hizo
  // para avisar, no para quedarse, y aquí el jugador está apuntando mientras lo lee. El toque
  // es la otra salida — ver hideToast.
  toastTimer = setTimeout(() => hideToast(), kind === 'award' ? 3200 : kind === 'reward' ? 2600 : 2400);
}

/** Puts the notice away. The timer is the usual way out; a tap at it is the other one. */
export function hideToast() {
  clearTimeout(toastTimer);
  toastTimer = null;
  toastEl.hidden = true;
}

// --- panels: modes, characters, leaderboards -------------------------------

/**
 * Every panel there is.
 *
 * A panel that is not in this list cannot be opened by anything: openPanel and
 * closePanels both work by walking it, so a missing entry means the element is
 * simply never touched. Wiring a button up to openPanel is not enough on its own
 * — this is the other half, and forgetting it looks exactly like a dead button.
 */
const ALL_PANELS = () => [awardPanel, charPanel, rankPanel, linkPanel, loadoutPanel];

/**
 * Only one panel is ever open, so opening one closes the rest.
 *
 * An open panel stops the turn clock, but not from here: advanceTurnClock asks
 * panelOpen() every frame. There is nothing to take hold of and nothing to give
 * back, so nothing can be left unbalanced by a panel closing twice.
 */
export function openPanel(panel) {
  ALL_PANELS().forEach(p => {
    p.hidden = p !== panel;
  });
  state.panelOpen = true;
}

export function closePanels() {
  ALL_PANELS().forEach(p => {
    p.hidden = true;
  });
  state.panelOpen = false;
}

/** True when any of them is showing, so Escape knows what it is closing. */
export function panelOpen() {
  return state.panelOpen;
}

/**
 * The mode cards, drawn straight into the setup screen. A mode is only ever a
 * bag of settings, so a card is a name, a line of explanation and a tick if it
 * is the one chosen — the border says which card, the tick says it a second time
 * for anyone who cannot see the colour.
 */
export function renderModes() {
  // La tarjeta marcada es la que se ha ELEGIDO, y no la de la partida en curso: elegir un modo con
  // una partida viva lo guarda para la siguiente (ver `newMatch` y el clic de la tarjeta), así que
  // marcar `state.mode` dejaba la marca clavada en el modo de la partida que se está jugando y el
  // jugador sin ver qué acababa de elegir. Medido antes de arreglarlo: con el ajuste en TERREMOTO,
  // la tarjeta marcada seguía siendo DEMOLITION.
  const chosenMode = savedMode();

  modeList.innerHTML = MODES.map(m => {
    const chosen = m.id === chosenMode;

    return `
      <button class="modecard" type="button" data-id="${m.id}" data-active="${chosen}" aria-pressed="${chosen}">
        <span class="mh">
          <span class="mi">${m.icon}</span>
          <span class="mn">${t('mode.' + m.id + '.name')}</span>
          ${chosen ? '<span class="mcheck" aria-hidden="true">✓</span>' : ''}
        </span>
        <span class="mb">${t('mode.' + m.id + '.blurb')}</span>
      </button>`;
  }).join('');
}

/** The whole setup screen: which rules, and who is holding the other controller. */
export function renderSetup() {
  renderModes();

  // aria-pressed for anyone listening, and a class for everyone looking.
  [[setupP1, state.cpuOn], [setupP2, !state.cpuOn]].forEach(([el, on]) => {
    el.setAttribute('aria-pressed', String(on));
    el.classList.toggle('chosen', on);
  });

  // The difficulty row is only for one player, and every path that can change that goes
  // through here — which is why it is painted here and not from the toggle.
  renderCpuChoices();
}

/** The card shown when a match ends. */
export function renderResults() {
  const winner = state.matchWins[0] > state.matchWins[1] ? 0 : 1;

  resultsHead.textContent = t('results.wins', { name: playerName(winner) });
  resultsScore.textContent = `${state.matchWins[0]} – ${state.matchWins[1]}`;
}

/**
 * The character panel: choose a species, then dress it.
 *
 * The whole wardrobe is here for everybody, from the first round. It used to be half
 * earned — a hat per achievement, greyed out with the requirement in its tooltip — which
 * is a perfectly good idea for a collection and the wrong one for a wardrobe, because it
 * makes getting dressed a reward for something else.
 */
export function renderCharacters() {
  const looks = savedLooks();

  // Whose side this panel is allowed to dress, and there are three answers rather than two.
  //
  // Over a wire the other player is not in the room and is not wearing what this machine has saved
  // for them: their character belongs to them, they choose it on their own device before the match,
  // and it arrives with their own codes (see adoptRivalLook). So this seat, and only this one.
  //
  // Against the CPU the rival is not somebody to dress either: it plays with whatever it came with,
  // and it never was configured from here. Spending half the panel on it is half a list nobody
  // scrolls, and that is exactly what it cost — measured, the panel came out at 2210 px in a hole
  // of 664 on a phone, with the lower half belonging to a gorilla that had no say in it.
  //
  // Two people on one keyboard are the exception, and the only one: both sides are in the room and
  // neither of them has anywhere else to choose, so that is the one case where this panel dresses
  // two gorillas.
  const sides = state.online ? [state.seat ? 1 : 0] : (state.cpuOn ? [0] : [0, 1]);

  charList.innerHTML = sides.map(side => {
    const look = looks[side];

    return `
      <div class="charside">
        <h3>${playerName(side)}</h3>

        <div class="speciesrow">
          ${SPECIES.map((s, i) => `
            <button class="species" type="button" data-side="${side}" data-species="${i}"
                    data-active="${look.species === i}"
                    title="${t('species.' + s.id)}">
              <img class="spicon" src="${speciesPreview(i)}" alt="" draggable="false">
              <span class="spname">${t('species.' + s.id)}</span>
            </button>`).join('')}
        </div>

        ${ACCESSORY_SLOTS.map(slot => `
          <div class="slotrow">
            <span class="slotname">${t('slot.' + slot)}</span>
            <span class="slotitems">
              ${ACCESSORIES.filter(a => a.slot === slot).map(a => `
                <button class="acc" type="button" data-side="${side}" data-slot="${slot}"
                        data-id="${a.id}" data-active="${look.worn[slot] === a.id}"
                        title="${t('accessory.' + a.id)}"
                        ><img src="${accessoryPreview(look.species, a)}" alt="" draggable="false"></button>`).join('')}
            </span>
          </div>`).join('')}
      </div>`;
  }).join('');
}

/**
 * Species or accessory, whichever was clicked. Kept here so the panel stays the
 * only place that knows what its own buttons mean.
 */
export function applyCharacterClick(el) {
  const side = Number(el.dataset.side);

  if (el.dataset.species !== undefined) {
    setLook(side, { species: Number(el.dataset.species) });
    return true;
  }

  if (el.dataset.id) {
    toggleAccessory(side, el.dataset.slot, el.dataset.id);
    return true;
  }

  return false;
}

const emptyRow = text => `<li class="rankempty">${text}</li>`;

/**
 * The language buttons. Two letters and a flag each, so they fit on one row and nobody has to
 * read a language name in a language they cannot read to find their own. The flag carries the
 * recognition and the letters carry the meaning, which is what keeps them short enough for six
 * of them: the row wraps if it ever has to.
 */
export function renderLangs() {
  if (!langRow) return;

  langRow.innerHTML = LANGS.map(l => `
    <button class="langbtn" type="button" data-lang="${l.id}"
            data-active="${l.id === lang()}" title="${l.label}"><i class="flag flag-${l.flag}" aria-hidden="true"></i>${l.id.toUpperCase()}</button>`).join('');
}

/**
 * The menu's two ways in, which depend on whether there is a match to go back to.
 *
 * This is the fix for ending up stranded: the only route out of the menu used to be
 * a new match, so leaving a live one to look at the leaderboards quietly threw the
 * score away and started over.
 */
export function updateMenuButtons() {
  if (!menuResume) return;

  menuResume.hidden = !state.matchLive;
  menuPlay.dataset.i18n = state.matchLive ? 'menu.newMatch' : 'menu.play';
  menuPlay.textContent = t(menuPlay.dataset.i18n);
  iconify(menuPlay);

  // The way back to the code, and only where there is a code: an online duel is one played by
  // code, so the pause offers the panel that carries it. Against the CPU or on one keyboard there
  // is nothing to send anybody, and the button would be a door to an empty box.
  if (pauseShare) pauseShare.hidden = !state.online;

  // The title's own button is one of these: what it says depends on the code field.
  updateJoinLabel();
}

/**
 * The button over the code field says what it will do with what is in it.
 *
 * Pressed with the field empty it goes to the menu, which is what PLAY NOW has always meant.
 * With a code in the field the same button goes straight into somebody else's match, and a
 * button still saying PLAY NOW there is promising the wrong thing — you would press it expecting
 * a menu and land in a duel. The data-i18n attribute goes with the text, or the language pass
 * would put PLAY NOW back over a full field on its own.
 *
 * Written from JavaScript rather than by the language pass, so it is called from
 * updateMenuButtons(): the one place a change of screen and a change of language both pass.
 */
export function updateJoinLabel() {
  if (!startBtn || !joinCode) return;

  const joining = !!joinCode.value.trim();

  startBtn.dataset.i18n = joining ? 'title.join' : 'title.start';
  startBtn.textContent = t(startBtn.dataset.i18n);
  iconify(startBtn);
}

/** Lo que ocupan los bordes de una caja en el eje que se le pida. */
function boxSize(el, side) {
  const cs = getComputedStyle(el);
  const parts = side === 'h'
    ? [cs.paddingLeft, cs.paddingRight, cs.borderLeftWidth, cs.borderRightWidth]
    : [cs.paddingTop, cs.paddingBottom, cs.borderTopWidth, cs.borderBottomWidth];
  return parts.reduce((sum, v) => sum + parseFloat(v || '0'), 0);
}

/**
 * Sizes the board to the screen fullscreen has just handed it, keeping its 16:9.
 *
 * The chrome is summed from its own pieces rather than taken as "the shell minus the
 * board". That subtraction is only the chrome while the shell is exactly as tall as the
 * board plus the chrome, and in fullscreen it is not — a browser stretches a fullscreen
 * element to the whole screen and its box is not open to argument — so the subtraction
 * counts empty air as chrome. On a 1600-wide window it reported sixteen pixels of chrome,
 * which were the shell's own padding, and the game put its header, its bar and its score
 * line out of sight behind an `overflow: hidden`. The pieces do not depend on the board,
 * so they cannot lie — as long as they are measured at the width they are going to keep.
 *
 * Which is where the two attempts come from. The width that makes the game line up — the
 * bar and the title as wide as the board, instead of stretched across the whole screen —
 * is also a narrower width, and on a small screen narrowing the header breaks it into more
 * lines, which makes the chrome taller, which takes room off the board. Chasing that with
 * a loop makes it worse, not better: on a 983×526 window it ended up with a 231-pixel
 * board under 468 pixels of chrome, neither of which fits anywhere. So the first width is
 * tried and measured, and if the game no longer fits in the screen the alignment is the
 * thing that gives way, not the game. The board's frame keeps its own width either way,
 * because the height of the board comes from it.
 */
export function fitFullscreen() {
  if (!document.fullscreenElement) {
    shellEl.style.removeProperty('--fs-board');
    shellEl.style.removeProperty('--fs-width');
    return;
  }

  const wrap = gameCanvas.parentElement;
  const frame = boxSize(wrap, 'h');
  // El cartel flotante no es chrome y no ocupa sitio: si está en pantalla cuando esto se mide
  // (un cartel dura 2,6 s y un móvil cambia de tamaño solo, al girar o al esconderse la barra del
  // navegador) su altura entraba en la cuenta y encogía el tablero esos mismos píxeles.
  const chrome = () => [...shellEl.children]
      .filter(el => el !== wrap && el.id !== 'toast')
      .reduce((sum, el) => sum + el.offsetHeight, 0)
    + boxSize(shellEl, 'v') + boxSize(wrap, 'v');

  const room = window.innerHeight - chrome();
  const board = Math.round(Math.max(320, Math.min(window.innerWidth, room * (960 / 540))));
  const width = board + frame + 'px';

  shellEl.style.setProperty('--fs-board', width);
  shellEl.style.setProperty('--fs-width', width);

  // The check is the screen itself, and it has to be the second reading of the chrome:
  // narrowing the shell is exactly what moves the header onto another line, so the first
  // reading — taken at the width we are leaving — is the one number that cannot be trusted.
  if (chrome() + gameCanvas.offsetHeight <= window.innerHeight + 1) return;

  shellEl.style.setProperty('--fs-width', '100%');
}

/**
 * The way into fullscreen, which is no longer a button: it is a double click on the field.
 *
 * There used to be a button in the corner as well, and it was removed on request — a phone held
 * sideways is already the widest thing two hands can hold, and the corner it sat in is where the
 * scoreboard is. What is left is the shortcut, which is what a fullscreen button mostly was
 * anyway: the field is the biggest thing on the screen and it is where a hand already goes.
 *
 * Escape is not ours and never was, and it is the reason this is safe: every browser gets you out
 * of fullscreen with it, so nothing on this screen can trap anybody in it. F11 belongs to the
 * browser too, and it goes through the same handler below.
 *
 * A double click on a slider or on the throw button is a double click on a control, and a control
 * keeps its own, so the listener is on the canvas and not on the corner it is drawn in.
 */
export function initFullscreen() {
  gameCanvas.addEventListener('dblclick', () => {
    if (document.fullscreenElement) document.exitFullscreen();
    else shellEl.requestFullscreen().catch(() => {});
  });

  document.addEventListener('fullscreenchange', fitFullscreen);
  window.addEventListener('resize', fitFullscreen);
}

/**
 * The line under the random button.
 *
 * It says how many are waiting, or that nobody is, or that there is no server to be waiting
 * on — and in that last case it says what will happen instead, because a button that cannot
 * do what it says is worse than a button that explains itself.
 */
export function renderPoolNote(status) {
  if (!poolNote) return;

  if (!status) poolNote.textContent = t('pool.noserver');
  else if (status.waiting) poolNote.textContent = t('pool.waiting', { n: status.waiting });
  else if (status.playing) poolNote.textContent = t('pool.playing', { n: status.playing, w: status.waiting });
  else poolNote.textContent = t('pool.none');
}

/** The setup screen out of the way, and the waiting panel in it. */
export function showSearching(on) {
  const setup = document.querySelector('#setup');
  if (setup) setup.toggleAttribute('data-searching', !!on);
  if (searching) searching.hidden = !on;
}

/** What the waiting panel is saying right now: who is coming, how long is left. */
export function setSearchingText(text) {
  if (searchText) searchText.textContent = text;
}

/**
 * Repaints every string on screen. setLang() rewrites the static markup itself;
 * this is for the parts that are drawn by code.
 */
export function refreshText() {
  renderLangs();
  // The share buttons carry translated tooltips built in the renderer, so they have
  // to be redrawn with the rest or they keep the language they were drawn in. Third
  // time this class of thing has bitten: anything assembled in JavaScript is not
  // covered by the data-i18n pass and has to be redrawn here by hand.
  renderSocial();
  renderLoadout();
  renderTurnChoices();
  renderTargetChoices();
  updateLabels();
  updateModeLabel();
  updateMenuButtons();
  // The header's music button carries a translated tooltip, so it has to be redrawn
  // with the rest or it keeps the old language's.
  updateMusicLabel();
  renderAwards();
  renderSetup();
  renderCharacters();
  renderRanks();
  updateSpecialButton();
}

/** A mode as its name, or the raw value for entries saved before modes had ids. */
function modeLabel(value) {
  if (!value) return '';
  return MODES.some(m => m.id === value) ? t('mode.' + value + '.name') : value;
}

/** Local entries carry a `winner`; entries from the shared board carry a `name`. */
function rankRow(entry, i) {
  const who = entry.name || entry.winner || '?';
  const when = entry.date || (entry.at ? new Date(entry.at).toISOString().slice(0, 10) : '');

  return `
    <li>
      <span class="rankpos">${i + 1}</span>
      <span><span class="rankwho">${who}</span><br><span class="rankmeta">${modeLabel(entry.mode)}${when ? ' · ' + when : ''}</span></span>
      <span class="rankmeta">${entry.wins}–${entry.losses}</span>
    </li>`;
}

/** The local leaderboard: best first, and always available offline. */
export function renderRanks() {
  const local = topResults(10);

  if (titleNameEl) titleNameEl.value = savedName();
  localList.innerHTML = local.length
    ? local.map(rankRow).join('')
    : emptyRow(t('rank.emptyLocal'));

  // `onlineStatus()` dice `noserver` y la clave es `lb.noServer`: con la mayúscula torcida,
  // `t()` devolvía la clave y el panel imprimía literalmente "lb.noserver".
  const why = onlineStatus();
  rankStatus.textContent = isOnline()
    ? t('lb.online')
    : t('lb.' + (why === 'noserver' ? 'noServer' : why));
}

/** Paints whatever the server sent back, or an explanation if it sent nothing. */
export function renderOnlineRanks(entries, note) {
  if (entries.length) {
    rankList.innerHTML = entries.map(rankRow).join('');
    return;
  }

  rankList.innerHTML = emptyRow(note || t('rank.emptyOnline'));
}

/** Says what happened, in the panel, where the player is already looking. */
export function setRankStatus(text) {
  rankStatus.textContent = text;
}
